import { Grid } from "antd-mobile";

export default Grid;
